import React from 'react'
import { useSupabaseAuth } from '../lib/useSupabaseAuth'

const ProtectedRoute = ({ children, requireVerification = true }) => {
  const { user, loading, isAuthenticated, needsEmailVerification, authReady } = useSupabaseAuth()

  // Show loading while auth is initializing
  if (loading || !authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white via-mint-50 to-primary-50">
        <div className="text-center">
          <div className="w-8 h-8 rounded-full border-4 border-primary-200 border-t-primary-500 animate-spin mb-4 mx-auto"></div>
          <p className="text-secondary font-medium">Verifying authentication...</p>
        </div>
      </div>
    )
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    // Redirect to login page
    window.location.href = '/login'
    return null
  }

  // User is authenticated and verified (if required), render children
  return children
}

export default ProtectedRoute

// Higher-order component for protecting specific components
export const withProtectedRoute = React.memo((WrappedComponent, requireUser = false) => {
  return function ProtectedComponent(props) {
    return (
      <ProtectedRoute requireUser={requireUser}>
        <WrappedComponent {...props} />
      </ProtectedRoute>
    )
  }
}) 